// Login routes (CADP)
export const LOGIN_ROUTES = {
  POST_LIST_BUSINESS_LINKS: '/v1/bff/cadp/listar-vinculo-negocio/filtrados',
  POST_GET_CONTACTS: '/v1/bff/cadp/consultar-contato',
  POST_SEND_SMS: '/v1/bff/cadp/enviar-sms',
  POST_SEND_EMAIL: '/v1/bff/cadp/enviar-email',
  POST_LOGIN_FINAL: '/v1/bff/cadp/login-final',
  
} as const;

// Gibs routes
export const GIBS_ROUTES = {
  POST_VERIFY_USER: '/v1/bff/gibs/verificar-usuario',
  POST_RECOVER_USER: '/v1/bff/gibs/recuperar-usuario',
  POST_RECOVER_PASSWORD: '/v1/bff/gibs/recuperar-senha',
} as const;

// Token session routes
export const TOKEN_SESSION_ROUTES = {
  GET_TOKEN_SESSION: '/v1/bff/sessao/validar',
} as const;

// Logout routes
export const LOGOUT_ROUTES = {
  LOGOUT: '/v1/bff/auth/logout',
} as const;

export const REGISTER_POLICYHOLDER_ROUTES = {
  POST_ADD_BASIC_PHYSICAL_PERSON_DATA: '/v1/bff/gibs/incluir-usuario',
  POST_GET_LEGAL_ENTITY_BY_CNPJ: '/v1/bff/cadp/recuperar-pessoa-juridica',
  POST_GET_PHYSICAL_PERSON_BY_CPF: '/v1/bff/cadp/recuperar-pessoa-fisica',
  POST_INCLUIR_RELACIONAMENTO_NEGOCIO: '/v1/bff/cadp/incluir-relacionamento-negocio',
  POST_LINK_PERSON_TO_BUSINESS_REPRESENTATION: '/v1/bff/cadp/vincular-pessoa-representacao-negocio',
  POST_LIST_BUSINESS_LINK_FILTERS: '/v1/bff/cadp/listar-vinculo-negocio/filtrados',
  POST_LIST_CONTACTS: '/v1/bff/cadp/consultar-contato',
  GET_LIST_POLICIES_FOR_USER: '/v1/bff/vida/apolice/listar-apol-perf-usuario',
  POST_ADD_EMAIL: '/v1/bff/cadp/adicionar-email',
  POST_ALTER_PASSWORD: '/v1/bff/gibs/alterar-senha',
} as const;

////////////////////////////////////////////////////////////
// Vida Service
////////////////////////////////////////////////////////////
export const VIDA_PAYMENT_ROUTES = {
  GET_PAYMENT_INVOICE_HISTORY: '/v1/bff/vida/faturamento/lista-faturas',
  GET_PAYMENT_INVOICE_DETAIL: '/v1/bff/vida/faturamento/obter-dados-fatura',
  GET_PAYMENT_INVOICE_COMPETENCE: '/v1/bff/vida/segurado/obter-competencias-faturadas',
} as const;

// Conferido com BffVidaController: @RequestMapping("v1/bff/vida") + @PostMapping("/dashboard/...")
export const VIDA_DASHBOARD_PAYMENT_ROUTES = {
  GET_DASHBOARD_PAYMENT_CORRETORA_ESTIPULANTE: '/v1/bff/vida/dashboard/resumo-corretora-estipulante',
  GET_DASHBOARD_PAYMENT_APOLICE: '/v1/bff/vida/dashboard/resumo-apolice',
  GET_DASHBOARD_PAYMENT_REPORT_CORRETOR_ESTIPULANTE: '/v1/bff/vida/dashboard/relatorio-corretor-estipulante',
  GET_DASHBOARD_PAYMENT_INVOICE_GRAPHIC: '/v1/bff/vida/dashboard/grafico-faturamento',
} as const;

// Vida Contracts routes
export const VIDA_CONTRACTS_ROUTES = {
  GET_CONTRACTS_AGE_LIMIT: '/v1/bff/vida/apolice/obter-dados-subestipulante-limite-de-idade-minima',
  GET_CONTRACTS_AGE_LIMIT_FIRST_CONTRACT: '/v1/bff/vida/apolice/obter-dados-subestipulante-limite-de-idade-maxima-para-primeira-fatura',
  GET_CONTRACTS_AGE_ALL_LIMIT_MAX_OTHER: '/v1/bff/vida/apolice/obter-dados-subestipulante-limite-de-idade-maxima-demais-faturas',
  GET_CONTRACTS_ESTIPULANT_CAPITAL_UNIFORM: '/v1/bff/vida/apolice/obter-dados-subestipulante-capital-uniforme',
  GET_CONTRACTS_ESTIPULANT_DATA: '/v1/bff/vida/apolice/obter-dados-estipulante',
  GET_CONTRACTS_COVERAGE: '/v1/bff/vida/apolice/obter-cobertura-apolice',
} as const;

// Vida Adhesion Proposal routes
export const VIDA_ADHESION_PROPOSAL_ROUTES = {
  GET_LIST_PROPOSAL_SUBESTIPULANTE: '/v1/bff/vida/proposta-adesao/obter-lista-proponente-subestipulante',
  GET_LIST_VALIDATION_PA_PROPOSITION: '/v1/bff/vida/proposta-adesao/obter-lista-validacao-pa-proponente',
  GET_HISTORY_PA_PROPOSAL: '/v1/bff/vida/proposta-adesao/obter-historico-parecer-pa',
  GET_REJECT_PA_PROPOSAL: '/v1/bff/vida/proposta-adesao/obter-motivo-recusa-pa',

} as const;

export const VIDA_ENUM_ROUTES = {
  GET_ENUM_TYPES_PERSON_ROLE: '/v1/bff/cadp/dominios-enum/tipos-papel-pessoa',
  GET_ENUM_DATA_SOURCES: '/v1/bff/cadp/dominios-enum/origens-dados',
  GET_ENUM_EDUCATION_LEVEL: '/v1/bff/cadp/dominios-enum/graus-escolaridade',
  GET_ENUM_CIVIL_STATUS: '/v1/bff/cadp/dominios-enum/estados-civis',
} as const;

export const ENTRA_ID_ROUTES = {
  AUTHORITY_HOST: 'https://login.microsoftonline.com',
  POST_ENTRA_LOGIN: '/v1/bff/auth/backoffice/entra-login',
} as const;

export const VIDA_PROTOCOL_ROUTES = {
  GET_GENERATE_PROTOCOL: '/v1/bff/vida/protocolo/gerar-protocolo-atendimento',
} as const;

export const VIDA_LIST_SUBESTIPULANTES_ROUTES = {
  GET_LIST_SUBESTIPULANTES: '/v1/bff/vida/apolice/obter-lista-subestipulantes',
} as const;

export const VIDA_PROPONENTE_MAINTENANCE_ROUTES = {
  POST_ADD_PROPONENTE_MAINTENANCE: '/v1/bff/vida/proposta-adesao/incluir-dados-proponente',
  POST_ALTER_PROPONENTE_MAINTENANCE: '/v1/bff/vida/proposta-adesao/alterar-dados-proponente',
  POST_IMPORT_PROPONENTE_MAINTENANCE_LOT: '/v1/bff/vida/proposta-adesao/importar-dados-proponente-lote',
  POST_CALCULATE_PROPONENTE_PREMIUM: '/v1/bff/vida/segurado/cotar-valor-premio-seguro',

  GET_INATIVATE_PROPONENTE_MAINTENANCE: '/v1/bff/vida/proposta-adesao/inativar-excluir-dados-proponente',
  GET_LIST_PROPONENTE_MAINTENANCE: '/v1/bff/vida/proposta-adesao/obter-lista-proponente-subestipulante',
  GET_PROPONENTE_MAINTENANCE_DETAIL: '/v1/bff/vida/proposta-adesao/obter-dados-proponente',
  GET_LAYOUT_IMPORT_SEGUR_VIDA: '/v1/bff/vida/faturamento/obter-layout-import-segur-vida',
} as const;

export const VIDA_SEGURADO_MAINTENANCE_ROUTES = {
  POST_ADD_SEGURADO_MAINTENANCE: '/v1/bff/vida/segurado/incluir-segurados-faturamento',
  POST_ADD_CONJUGUE_SEGURADO_MAINTENANCE: '/v1/bff/vida/segurado/incluir-conjugue-segurados-faturamento',
  POST_REMOVE_SEGURADO_MAINTENANCE: '/v1/bff/vida/segurado/excluir-segurados-faturamento',
  POST_ALTER_SEGURADO_MAINTENANCE: '/v1/bff/vida/segurado/alterar-segurados-faturamento',
  GET_LIST_SEGURADO_MAINTENANCE: '/v1/bff/vida/segurado/obter-lista-segurado',
  GET_SEGURADO_MAINTENANCE_DETAIL: '/v1/bff/vida/segurado/obter-detalhe-segurado-faturamento',
  GET_CONSULTAR_SEGURADOS_FATURAMENTO: '/v1/bff/vida/segurado/consultar-segurados-faturamento',
} as const;

export const VIDA_CEP_ROUTES = {
  GET_OBTER_DADOS_LOGRADOURO_CONSULTA_CEP: '/v1/bff/vida/segurado/obter-dados-logradouro-consulta-cep',
} as const;

export const DREF_ROUTES = {
  POST_VERIFY_ACCEPTANCE: '/v1/bff/dref/verificar-aceite',
  POST_REMOVE_ACCEPTANCE: '/v1/bff/dref/remover-aceite',
  POST_RECOVER_TERM_BY_IDENTIFIER: '/v1/bff/dref/recuperar-termo-por-identificador',
  POST_LIST_TERMS_BY_IDENTIFIER: '/v1/bff/dref/listar-termos-por-identificador',
  POST_INCLUDE_ACCEPTANCE: '/v1/bff/dref/incluir-aceite',
} as const;

////////////////////////////////////////////////////////////
// Previdência 
////////////////////////////////////////////////////////////

// Previdência Participants routes
export const PREVIDENCIA_PARTICIPANTS_ROUTES = {
  GET_SEARCH_PARTICIPANTS: '/v1/bff/previdencia/participants/search',
  GET_PARTICIPANT_DETAIL: '/v1/bff/previdencia/participants/detail',
  PUT_UPDATE_PARTICIPANT: '/v1/bff/previdencia/update-participant',
  GET_CONTRACTS: '/v1/bff/previdencia/contracts',
} as const;

// Previdência Download Adhesion routes
export const PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES = {
  POST_DOWNLOAD_ADHESION: '/v1/bff/previdencia/adhesions/download',
  GET_LIST_ADHESIONS: '/v1/bff/previdencia/adhesions',
  GET_ADHESION_DETAIL: '/v1/bff/previdencia/adhesions/detail',
} as const;

// Previdência Subcompanies routes
export const PREVIDENCIA_SUBCOMPANIES_ROUTES = {
  GET_SUBCOMPANIES: '/v1/bff/previdencia/subcompanies',
} as const;

// Previdência Digital Invoicing routes
export const PREVIDENCIA_DIGITAL_INVOICING_ROUTES = {
  POST_PAYMENT_DOWNLOAD: '/v1/bff/previdencia/payments/download',
  GET_PAYMENTS: '/v1/bff/previdencia/payments',
  GET_PAYMENT_DETAIL: '/v1/bff/previdencia/payments/detail',
} as const;

// Portal do Estipulante / Web Vida auto-login
export const PORTAL_ESTIPULANTE_ROUTES = {
  POST_REDIRECT: '/v1/bff/portal-estipulante/redirect',
} as const;
